module.exports = __webpack_public_path__ + "img/add-tip.43680a64.png";